import React from 'react';

const PhoneFormatter = ({ phone, country }) => {
    const countries = [
        { code: 'AF', name: 'Afeganistão', flag: '🇦🇫', dial: '+93' },
        { code: 'ZA', name: 'África do Sul', flag: '🇿🇦', dial: '+27' },
        { code: 'AL', name: 'Albânia', flag: '🇦🇱', dial: '+355' },
        { code: 'DE', name: 'Alemanha', flag: '🇩🇪', dial: '+49' },
        { code: 'AD', name: 'Andorra', flag: '🇦🇩', dial: '+376' },
        { code: 'AO', name: 'Angola', flag: '🇦🇴', dial: '+244' },
        { code: 'AG', name: 'Antígua e Barbuda', flag: '🇦🇬', dial: '+1' },
        { code: 'SA', name: 'Arábia Saudita', flag: '🇸🇦', dial: '+966' },
        { code: 'DZ', name: 'Argélia', flag: '🇩🇿', dial: '+213' },
        { code: 'AR', name: 'Argentina', flag: '🇦🇷', dial: '+54' },
        { code: 'AM', name: 'Armênia', flag: '🇦🇲', dial: '+374' },
        { code: 'AU', name: 'Austrália', flag: '🇦🇺', dial: '+61' },
        { code: 'AT', name: 'Áustria', flag: '🇦🇹', dial: '+43' },
        { code: 'AZ', name: 'Azerbaijão', flag: '🇦🇿', dial: '+994' },
        { code: 'BS', name: 'Bahamas', flag: '🇧🇸', dial: '+1' },
        { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', dial: '+880' },
        { code: 'BB', name: 'Barbados', flag: '🇧🇧', dial: '+1' },
        { code: 'BH', name: 'Bahrein', flag: '🇧🇭', dial: '+973' },
        { code: 'BE', name: 'Bélgica', flag: '🇧🇪', dial: '+32' },
        { code: 'BZ', name: 'Belize', flag: '🇧🇿', dial: '+501' },
        { code: 'BJ', name: 'Benin', flag: '🇧🇯', dial: '+229' },
        { code: 'BT', name: 'Butão', flag: '🇧🇹', dial: '+975' },
        { code: 'BY', name: 'Bielorrússia', flag: '🇧🇾', dial: '+375' },
        { code: 'BO', name: 'Bolívia', flag: '🇧🇴', dial: '+591' },
        { code: 'BA', name: 'Bósnia e Herzegovina', flag: '🇧🇦', dial: '+387' },
        { code: 'BW', name: 'Botsuana', flag: '🇧🇼', dial: '+267' },
        { code: 'BR', name: 'Brasil', flag: '🇧🇷', dial: '+55' },
        { code: 'BN', name: 'Brunei', flag: '🇧🇳', dial: '+673' },
        { code: 'BG', name: 'Bulgária', flag: '🇧🇬', dial: '+359' },
        { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫', dial: '+226' },
        { code: 'BI', name: 'Burundi', flag: '🇧🇮', dial: '+257' },
        { code: 'CV', name: 'Cabo Verde', flag: '🇨🇻', dial: '+238' },
        { code: 'CM', name: 'Camarões', flag: '🇨🇲', dial: '+237' },
        { code: 'KH', name: 'Camboja', flag: '🇰🇭', dial: '+855' },
        { code: 'CA', name: 'Canadá', flag: '🇨🇦', dial: '+1' },
        { code: 'QA', name: 'Catar', flag: '🇶🇦', dial: '+974' },
        { code: 'KZ', name: 'Cazaquistão', flag: '🇰🇿', dial: '+7' },
        { code: 'TD', name: 'Chade', flag: '🇹🇩', dial: '+235' },
        { code: 'CL', name: 'Chile', flag: '🇨🇱', dial: '+56' },
        { code: 'CN', name: 'China', flag: '🇨🇳', dial: '+86' },
        { code: 'CY', name: 'Chipre', flag: '🇨🇾', dial: '+357' },
        { code: 'CO', name: 'Colômbia', flag: '🇨🇴', dial: '+57' },
        { code: 'KM', name: 'Comores', flag: '🇰🇲', dial: '+269' },
        { code: 'CG', name: 'Congo', flag: '🇨🇬', dial: '+242' },
        { code: 'KP', name: 'Coreia do Norte', flag: '🇰🇵', dial: '+850' },
        { code: 'KR', name: 'Coreia do Sul', flag: '🇰🇷', dial: '+82' },
        { code: 'CI', name: 'Costa do Marfim', flag: '🇨🇮', dial: '+225' },
        { code: 'CR', name: 'Costa Rica', flag: '🇨🇷', dial: '+506' },
        { code: 'HR', name: 'Croácia', flag: '🇭🇷', dial: '+385' },
        { code: 'CU', name: 'Cuba', flag: '🇨🇺', dial: '+53' },
        { code: 'DK', name: 'Dinamarca', flag: '🇩🇰', dial: '+45' },
        { code: 'DJ', name: 'Djibuti', flag: '🇩🇯', dial: '+253' },
        { code: 'DM', name: 'Dominica', flag: '🇩🇲', dial: '+1' },
        { code: 'EG', name: 'Egito', flag: '🇪🇬', dial: '+20' },
        { code: 'SV', name: 'El Salvador', flag: '🇸🇻', dial: '+503' },
        { code: 'AE', name: 'Emirados Árabes Unidos', flag: '🇦🇪', dial: '+971' },
        { code: 'EC', name: 'Equador', flag: '🇪🇨', dial: '+593' },
        { code: 'ER', name: 'Eritreia', flag: '🇪🇷', dial: '+291' },
        { code: 'SK', name: 'Eslováquia', flag: '🇸🇰', dial: '+421' },
        { code: 'SI', name: 'Eslovênia', flag: '🇸🇮', dial: '+386' },
        { code: 'ES', name: 'Espanha', flag: '🇪🇸', dial: '+34' },
        { code: 'US', name: 'Estados Unidos', flag: '🇺🇸', dial: '+1' },
        { code: 'EE', name: 'Estônia', flag: '🇪🇪', dial: '+372' },
        { code: 'ET', name: 'Etiópia', flag: '🇪🇹', dial: '+251' },
        { code: 'FJ', name: 'Fiji', flag: '🇫🇯', dial: '+679' },
        { code: 'PH', name: 'Filipinas', flag: '🇵🇭', dial: '+63' },
        { code: 'FI', name: 'Finlândia', flag: '🇫🇮', dial: '+358' },
        { code: 'FR', name: 'França', flag: '🇫🇷', dial: '+33' },
        { code: 'GA', name: 'Gabão', flag: '🇬🇦', dial: '+241' },
        { code: 'GM', name: 'Gâmbia', flag: '🇬🇲', dial: '+220' },
        { code: 'GH', name: 'Gana', flag: '🇬🇭', dial: '+233' },
        { code: 'GE', name: 'Geórgia', flag: '🇬🇪', dial: '+995' },
        { code: 'GD', name: 'Granada', flag: '🇬🇩', dial: '+1' },
        { code: 'GR', name: 'Grécia', flag: '🇬🇷', dial: '+30' },
        { code: 'GT', name: 'Guatemala', flag: '🇬🇹', dial: '+502' },
        { code: 'GY', name: 'Guiana', flag: '🇬🇾', dial: '+592' },
        { code: 'GN', name: 'Guiné', flag: '🇬🇳', dial: '+224' },
        { code: 'GW', name: 'Guiné-Bissau', flag: '🇬🇼', dial: '+245' },
        { code: 'GQ', name: 'Guiné Equatorial', flag: '🇬🇶', dial: '+240' },
        { code: 'HT', name: 'Haiti', flag: '🇭🇹', dial: '+509' },
        { code: 'NL', name: 'Holanda', flag: '🇳🇱', dial: '+31' },
        { code: 'HN', name: 'Honduras', flag: '🇭🇳', dial: '+504' },
        { code: 'HU', name: 'Hungria', flag: '🇭🇺', dial: '+36' },
        { code: 'YE', name: 'Iêmen', flag: '🇾🇪', dial: '+967' },
        { code: 'IN', name: 'Índia', flag: '🇮🇳', dial: '+91' },
        { code: 'ID', name: 'Indonésia', flag: '🇮🇩', dial: '+62' },
        { code: 'IR', name: 'Irã', flag: '🇮🇷', dial: '+98' },
        { code: 'IQ', name: 'Iraque', flag: '🇮🇶', dial: '+964' },
        { code: 'IE', name: 'Irlanda', flag: '🇮🇪', dial: '+353' },
        { code: 'IS', name: 'Islândia', flag: '🇮🇸', dial: '+354' },
        { code: 'IL', name: 'Israel', flag: '🇮🇱', dial: '+972' },
        { code: 'IT', name: 'Itália', flag: '🇮🇹', dial: '+39' },
        { code: 'JM', name: 'Jamaica', flag: '🇯🇲', dial: '+1' },
        { code: 'JP', name: 'Japão', flag: '🇯🇵', dial: '+81' },
        { code: 'JO', name: 'Jordânia', flag: '🇯🇴', dial: '+962' },
        { code: 'XK', name: 'Kosovo', flag: '🇽🇰', dial: '+383' },
        { code: 'KW', name: 'Kuwait', flag: '🇰🇼', dial: '+965' },
        { code: 'LA', name: 'Laos', flag: '🇱🇦', dial: '+856' },
        { code: 'LS', name: 'Lesoto', flag: '🇱🇸', dial: '+266' },
        { code: 'LV', name: 'Letônia', flag: '🇱🇻', dial: '+371' },
        { code: 'LB', name: 'Líbano', flag: '🇱🇧', dial: '+961' },
        { code: 'LR', name: 'Libéria', flag: '🇱🇷', dial: '+231' },
        { code: 'LY', name: 'Líbia', flag: '🇱🇾', dial: '+218' },
        { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮', dial: '+423' },
        { code: 'LT', name: 'Lituânia', flag: '🇱🇹', dial: '+370' },
        { code: 'LU', name: 'Luxemburgo', flag: '🇱🇺', dial: '+352' },
        { code: 'MK', name: 'Macedônia do Norte', flag: '🇲🇰', dial: '+389' },
        { code: 'MG', name: 'Madagascar', flag: '🇲🇬', dial: '+261' },
        { code: 'MY', name: 'Malásia', flag: '🇲🇾', dial: '+60' },
        { code: 'MW', name: 'Malawi', flag: '🇲🇼', dial: '+265' },
        { code: 'MV', name: 'Maldivas', flag: '🇲🇻', dial: '+960' },
        { code: 'ML', name: 'Mali', flag: '🇲🇱', dial: '+223' },
        { code: 'MT', name: 'Malta', flag: '🇲🇹', dial: '+356' },
        { code: 'MA', name: 'Marrocos', flag: '🇲🇦', dial: '+212' },
        { code: 'MU', name: 'Maurício', flag: '🇲🇺', dial: '+230' },
        { code: 'MR', name: 'Mauritânia', flag: '🇲🇷', dial: '+222' },
        { code: 'MX', name: 'México', flag: '🇲🇽', dial: '+52' },
        { code: 'MM', name: 'Mianmar', flag: '🇲🇲', dial: '+95' },
        { code: 'MZ', name: 'Moçambique', flag: '🇲🇿', dial: '+258' },
        { code: 'MD', name: 'Moldávia', flag: '🇲🇩', dial: '+373' },
        { code: 'MC', name: 'Mônaco', flag: '🇲🇨', dial: '+377' },
        { code: 'MN', name: 'Mongólia', flag: '🇲🇳', dial: '+976' },
        { code: 'ME', name: 'Montenegro', flag: '🇲🇪', dial: '+382' },
        { code: 'NA', name: 'Namíbia', flag: '🇳🇦', dial: '+264' },
        { code: 'NP', name: 'Nepal', flag: '🇳🇵', dial: '+977' },
        { code: 'NI', name: 'Nicarágua', flag: '🇳🇮', dial: '+505' },
        { code: 'NE', name: 'Níger', flag: '🇳🇪', dial: '+227' },
        { code: 'NG', name: 'Nigéria', flag: '🇳🇬', dial: '+234' },
        { code: 'NO', name: 'Noruega', flag: '🇳🇴', dial: '+47' },
        { code: 'NZ', name: 'Nova Zelândia', flag: '🇳🇿', dial: '+64' },
        { code: 'OM', name: 'Omã', flag: '🇴🇲', dial: '+968' },
        { code: 'PW', name: 'Palau', flag: '🇵🇼', dial: '+680' },
        { code: 'PS', name: 'Palestina', flag: '🇵🇸', dial: '+970' },
        { code: 'PA', name: 'Panamá', flag: '🇵🇦', dial: '+507' },
        { code: 'PG', name: 'Papua-Nova Guiné', flag: '🇵🇬', dial: '+675' },
        { code: 'PK', name: 'Paquistão', flag: '🇵🇰', dial: '+92' },
        { code: 'PY', name: 'Paraguai', flag: '🇵🇾', dial: '+595' },
        { code: 'PE', name: 'Peru', flag: '🇵🇪', dial: '+51' },
        { code: 'PL', name: 'Polônia', flag: '🇵🇱', dial: '+48' },
        { code: 'PT', name: 'Portugal', flag: '🇵🇹', dial: '+351' },
        { code: 'KE', name: 'Quênia', flag: '🇰🇪', dial: '+254' },
        { code: 'KG', name: 'Quirguistão', flag: '🇰🇬', dial: '+996' },
        { code: 'GB', name: 'Reino Unido', flag: '🇬🇧', dial: '+44' },
        { code: 'CF', name: 'República Centro-Africana', flag: '🇨🇫', dial: '+236' },
        { code: 'CZ', name: 'República Tcheca', flag: '🇨🇿', dial: '+420' },
        { code: 'DO', name: 'República Dominicana', flag: '🇩🇴', dial: '+1' },
        { code: 'RO', name: 'Romênia', flag: '🇷🇴', dial: '+40' },
        { code: 'RW', name: 'Ruanda', flag: '🇷🇼', dial: '+250' },
        { code: 'RU', name: 'Rússia', flag: '🇷🇺', dial: '+7' },
        { code: 'SB', name: 'Salomão', flag: '🇸🇧', dial: '+677' },
        { code: 'WS', name: 'Samoa', flag: '🇼🇸', dial: '+685' },
        { code: 'LC', name: 'Santa Lúcia', flag: '🇱🇨', dial: '+1' },
        { code: 'KN', name: 'São Cristóvão e Nevis', flag: '🇰🇳', dial: '+1' },
        { code: 'SM', name: 'São Marino', flag: '🇸🇲', dial: '+378' },
        { code: 'ST', name: 'São Tomé e Príncipe', flag: '🇸🇹', dial: '+239' },
        { code: 'VC', name: 'São Vicente e Granadinas', flag: '🇻🇨', dial: '+1' },
        { code: 'SN', name: 'Senegal', flag: '🇸🇳', dial: '+221' },
        { code: 'SL', name: 'Serra Leoa', flag: '🇸🇱', dial: '+232' },
        { code: 'RS', name: 'Sérvia', flag: '🇷🇸', dial: '+381' },
        { code: 'SG', name: 'Singapura', flag: '🇸🇬', dial: '+65' },
        { code: 'SY', name: 'Síria', flag: '🇸🇾', dial: '+963' },
        { code: 'SO', name: 'Somália', flag: '🇸🇴', dial: '+252' },
        { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰', dial: '+94' },
        { code: 'SD', name: 'Sudão', flag: '🇸🇩', dial: '+249' },
        { code: 'SS', name: 'Sudão do Sul', flag: '🇸🇸', dial: '+211' },
        { code: 'SE', name: 'Suécia', flag: '🇸🇪', dial: '+46' },
        { code: 'CH', name: 'Suíça', flag: '🇨🇭', dial: '+41' },
        { code: 'SR', name: 'Suriname', flag: '🇸🇷', dial: '+597' },
        { code: 'TH', name: 'Tailândia', flag: '🇹🇭', dial: '+66' },
        { code: 'TW', name: 'Taiwan', flag: '🇹🇼', dial: '+886' },
        { code: 'TJ', name: 'Tajiquistão', flag: '🇹🇯', dial: '+992' },
        { code: 'TZ', name: 'Tanzânia', flag: '🇹🇿', dial: '+255' },
        { code: 'TL', name: 'Timor-Leste', flag: '🇹🇱', dial: '+670' },
        { code: 'TG', name: 'Togo', flag: '🇹🇬', dial: '+228' },
        { code: 'TO', name: 'Tonga', flag: '🇹🇴', dial: '+676' },
        { code: 'TT', name: 'Trinidad e Tobago', flag: '🇹🇹', dial: '+1' },
        { code: 'TN', name: 'Tunísia', flag: '🇹🇳', dial: '+216' },
        { code: 'TM', name: 'Turcomenistão', flag: '🇹🇲', dial: '+993' },
        { code: 'TR', name: 'Turquia', flag: '🇹🇷', dial: '+90' },
        { code: 'TV', name: 'Tuvalu', flag: '🇹🇻', dial: '+688' },
        { code: 'UA', name: 'Ucrânia', flag: '🇺🇦', dial: '+380' },
        { code: 'UG', name: 'Uganda', flag: '🇺🇬', dial: '+256' },
        { code: 'UY', name: 'Uruguai', flag: '🇺🇾', dial: '+598' },
        { code: 'UZ', name: 'Uzbequistão', flag: '🇺🇿', dial: '+998' },
        { code: 'VU', name: 'Vanuatu', flag: '🇻🇺', dial: '+678' },
        { code: 'VA', name: 'Vaticano', flag: '🇻🇦', dial: '+39' },
        { code: 'VE', name: 'Venezuela', flag: '🇻🇪', dial: '+58' },
        { code: 'VN', name: 'Vietnã', flag: '🇻🇳', dial: '+84' },
        { code: 'ZM', name: 'Zâmbia', flag: '🇿🇲', dial: '+260' },
        { code: 'ZW', name: 'Zimbábue', flag: '🇿🇼', dial: '+263' }
    ];

    const formatPhoneByCountry = (phone, countryCode) => {
        if (!phone) return '';

        const cleanPhone = phone.replace(/\D/g, '');

        const formatPatterns = {
            'BR': (num) => {
                if (num.length === 11) {
                    return `(${num.slice(0, 2)}) ${num.slice(2, 7)}-${num.slice(7)}`;
                } else if (num.length === 10) {
                    return `(${num.slice(0, 2)}) ${num.slice(2, 6)}-${num.slice(6)}`;
                }
                return num;
            },
            'US': (num) => {
                if (num.length === 10) {
                    return `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`;
                }
                return num;
            },
            'CA': (num) => {
                if (num.length === 10) {
                    return `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`;
                }
                return num;
            },
            'GB': (num) => {
                if (num.length === 10) {
                    return `${num.slice(0, 4)} ${num.slice(4, 7)} ${num.slice(7)}`;
                } else if (num.length === 11) {
                    return `${num.slice(0, 5)} ${num.slice(5, 8)} ${num.slice(8)}`;
                }
                return num;
            },
            'FR': (num) => {
                if (num.length === 9) {
                    return `${num.slice(0, 1)} ${num.slice(1, 3)} ${num.slice(3, 5)} ${num.slice(5, 7)} ${num.slice(7)}`;
                } else if (num.length === 10) {
                    return `${num.slice(0, 2)} ${num.slice(2, 4)} ${num.slice(4, 6)} ${num.slice(6, 8)} ${num.slice(8)}`;
                }
                return num;
            },
            'DE': (num) => {
                if (num.length >= 10) {
                    return `${num.slice(0, 3)} ${num.slice(3)}`;
                }
                return num;
            },
            'ES': (num) => {
                if (num.length === 9) {
                    return `${num.slice(0, 3)} ${num.slice(3, 5)} ${num.slice(5, 7)} ${num.slice(7)}`;
                }
                return num;
            },
            'IT': (num) => {
                if (num.length === 10) {
                    return `${num.slice(0, 3)} ${num.slice(3, 6)} ${num.slice(6)}`;
                }
                return num;
            },
            'AR': (num) => {
                if (num.length === 10) {
                    return `${num.slice(0, 2)} ${num.slice(2, 6)}-${num.slice(6)}`;
                }
                return num;
            },
            'MX': (num) => {
                if (num.length === 10) {
                    return `${num.slice(0, 2)} ${num.slice(2, 6)} ${num.slice(6)}`;
                }
                return num;
            },
            'CL': (num) => {
                if (num.length === 9) {
                    return `${num.slice(0, 1)} ${num.slice(1, 5)} ${num.slice(5)}`;
                }
                return num;
            },
            'JP': (num) => {
                if (num.length === 10) {
                    return `${num.slice(0, 3)}-${num.slice(3, 7)}-${num.slice(7)}`;
                } else if (num.length === 11) {
                    return `${num.slice(0, 3)}-${num.slice(3, 7)}-${num.slice(7)}`;
                }
                return num;
            },
            'CN': (num) => {
                if (num.length === 11) {
                    return `${num.slice(0, 3)} ${num.slice(3, 7)} ${num.slice(7)}`;
                }
                return num;
            },
            'AU': (num) => {
                if (num.length === 9) {
                    return `${num.slice(0, 4)} ${num.slice(4, 7)} ${num.slice(7)}`;
                }
                return num;
            },
            'PT': (num) => {
                if (num.length === 9) {
                    return `${num.slice(0, 3)} ${num.slice(3, 6)} ${num.slice(6)}`;
                }
                return num;
            },
            'IN': (num) => {
                if (num.length === 10) {
                    return `${num.slice(0, 5)} ${num.slice(5)}`;
                }
                return num;
            }
        };

        const formatter = formatPatterns[countryCode];
        if (formatter) {
            return formatter(cleanPhone);
        }

        if (cleanPhone.length >= 8) {
            const groups = cleanPhone.match(/.{1,3}/g);
            return groups.join(' ');
        }

        return cleanPhone;
    };

    const countryData = countries.find(c => c.code === country);

    if (!countryData) {
        return <span>Não Informado</span>;
    }

    const formattedPhone = formatPhoneByCountry(phone, country);

    return (
        <span>
            {countryData.flag} {countryData.dial} {formattedPhone}
        </span>
    );
};

export default PhoneFormatter;